import { type UiLibI18n } from '@myre/domain-i18n-wordings';

import { Component, computed, inject, input } from '@angular/core';

import { WORDINGS } from '../../myre-wordings-loader';

/**
 * Component that displays agent status updates (thoughts/processing status)
 * during streaming.
 */
@Component({
  selector: 'app-agent-status',
  templateUrl: './agent-status.component.html',
  styleUrl: './agent-status.component.css',
})
export class AgentStatusComponent {
  protected readonly _wordings = inject<UiLibI18n>(WORDINGS);

  public statusText = input<string | null>(null);

  /** Strip trailing ellipsis that some backends append */
  protected readonly _cleanedText = computed(() => {
    if (!this.statusText()) {
      return null;
    }

    return this.statusText().replace(/\.\.\.$/, '');
  });
}
